import FruitsAndVeg from "./FruitsAndVeg.jsx";
export default FruitsAndVeg